import { createSlice } from "@reduxjs/toolkit";

const defaultPagination = {
  page: 0,
  pageSize: 50,
};

const baseInvoiceFilterState = {
  pagination: { ...defaultPagination },

  creationStartDate: "",
  creationEndDate: "",
  dueStartDate: "",
  dueEndDate: "",

  generatedBy: { value: "", label: "" },
  reviewedBy: { value: "", label: "" },
  sendBy: { value: "", label: "" },
  paidBy: { value: "", label: "" },

  status: { value: "", label: "" },
  tax: "",
  search: "",
  id: "",

  appliedFromDrawer: false,
};

const initialState = {
  customerInvoices: { ...baseInvoiceFilterState, customer: { value: "", label: "" }, },
  engineerInvoices: { ...baseInvoiceFilterState, engineer: { value: "", label: "" }, },
};

const invoiceFiltersSlice = createSlice({
  name: "invoiceFilters",
  initialState,
  reducers: {
    setInvoiceFilters: (state, action) => {
      const { module, filterName, data } = action.payload;

      if (!state[module]) return;

      if (filterName === "pagination") {
        state[module].pagination = {
          ...state[module].pagination,
          ...data,
        };
      }
      else if (filterName.includes(".")) {
        const [parent, child] = filterName.split(".");
        if (state[module][parent]) {
          state[module][parent][child] = data;
        }
      }
      else {
        state[module][filterName] = data;
      }
    },

    resetInvoiceFilters: (state, action) => {
      const { module } = action.payload;
      if (initialState[module]) {
        state[module] = { ...initialState[module] };
      }
    },

    resetInvoicePagination: (state, action) => {
      const { module } = action.payload;
      if (state[module]) {
        state[module].pagination = { ...defaultPagination };
      }
    },
  },
});

export const {
  setInvoiceFilters,
  resetInvoiceFilters,
  resetInvoicePagination,
} = invoiceFiltersSlice.actions;

export default invoiceFiltersSlice.reducer;
